import React from "react";
import Link from "./link";

import { GlobalStore } from "../../stores/global";

const MiniCta = ({ content }) => {
  const { currentCountryCode: countryCode } = GlobalStore.useState(c => c);
  const { header, booknow, booknowlink, downloadappcaption, downloadapplink } = content;

  const gotoBookNow = () => {
    if (booknowlink) {
      window.location.href = booknowlink.toLowerCase().replace(/:country/, countryCode.toLowerCase());
    } else {
      window.scrollTo({ behavior: "smooth", left: 0, top: 0 });
    }
  };

  return (
    <div id="miniCta">
      <div className="wrap">
        <div className="header">{header}</div>
        <div className="btnContainer">
          <div className="btn primary" onClick={gotoBookNow}>
            <span>{booknow}</span>
          </div>
          {downloadappcaption && downloadapplink && (
            <div className="btn secondary">
              <Link
                link={downloadapplink && downloadapplink.toLowerCase().replace(/:country/, countryCode.toLowerCase())}
                text={
                  <>
                    <span>{downloadappcaption}</span>
                  </>
                }
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MiniCta;
